export default __webpack_public_path__ + "static/header-8961993fa48e5d4e1b8ade3774778375.png";